import { render, staticRenderFns } from "./Subcategory.vue?vue&type=template&id=5910b67e&"
import script from "./Subcategory.vue?vue&type=script&lang=js&"
export * from "./Subcategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports